// Function to set the height of all .hero elements
const setHeroHeights = () => {
  const heros = document.querySelectorAll('.hero,.hero-carousel');
  heros.forEach(hero => {
    // Remove any inline style height to get the CSS dictated height
    hero.style.height = '';
    // Get the computed height from CSS
    const computedHeight = window.getComputedStyle(hero).height;
    // Set the inline height to the computed height
    hero.style.height = computedHeight;
  });
};

// Initialize hero heights on page load
setHeroHeights();

// Variable to store the current width of the document
let currentWidth = window.innerWidth;

// Add event listener to adjust the hero heights only if the width changes
window.addEventListener('resize', () => {
  if (window.innerWidth !== currentWidth) {
    currentWidth = window.innerWidth;
    setHeroHeights();
  }
});
